import Logger from 'js-logger';

import { ILoggerOptions } from './types';

const LOCAL_STORAGE_IS_LOG_KEY = 'isLogEnabled';

export const logger = Logger;

export function setLoggerConfig(config: ILoggerOptions): void {
  logger.useDefaults({
    defaultLevel: config.enabled ? Logger.TRACE : Logger.OFF,
    formatter: function (messages, context) {
      const d = new Date();
      const time = d.toTimeString().split(' ')[0] + ':' + d.getMilliseconds();

      const templatesMessages = [`%c${time} %c${context.name ? `[${context.name}]` : ''}`];

      const newMessages = ['color: #91a1a1;', `font-size: 1.1em; font-weight: bold;`];

      if (typeof messages[0] === 'string' && messages[0].indexOf('%c') !== -1) {
        templatesMessages.push(messages.shift());
      }

      newMessages.unshift(templatesMessages.join(' '));
      messages.unshift(...newMessages);
    },
  });
}

export function isLogEnabled(): boolean {
  return localStorage.getItem(LOCAL_STORAGE_IS_LOG_KEY) === 'true';
}

export function setIsLogEnabled(enabled: boolean): void {
  localStorage.setItem(LOCAL_STORAGE_IS_LOG_KEY, String(enabled));
  logger.setLevel(enabled ? Logger.TRACE : Logger.OFF);
}
